/**
 * Do not remove any keys!!
 * The shape of this file is to remain the same so that all options are know.
 *
 * If a key does not have a value, set the value to undefined.
 */
module.exports = {
  communityName: "Laguna Farms",
  gtagId: "G-JTRLDJL996",
  logo: {
    src: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/Laguna Farms Logo- Blck@4x.png",
    alt: "Laguna Farms Logo",
  },
  nav: {
    bannerSubtitle: undefined,
    bannerTitle: undefined,
    bannerCTA: undefined,
  },
  footer: {
    address: "16852 Idaho Center Blvd",
    cityStateZip: "Nampa, ID 83687",
    phone: "(208) 505-6676",
    copyrightYear: "2024",
    logo: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/logo_white@2x.png",
  },
  listMarkerSrc: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/bullet point laguna logo.png",
  hasShowingPopup: true,
  home: {
    banner: {
      image: undefined,
      video: "https://cdn.maxxpm.com/lagunafarms/Master_Website_Drone_Loop_4k_003.mp4",
      title: "Now Leasing",
      subtitle: undefined,
      openHouse: {
        start: new Date("2025-04-11T10:00:00.000-06:00"),
        end: new Date("2025-04-11T13:00:00.000-06:00"),
        image: "https://cdn.maxxpm.com/lagunafarms/Website Photos/_DSC0413-Edit.jpg",
      },
    },
    aboutUs: {
      paragraphs: [
        "Laguna Farms Townhomes is a modern and welcoming community located in Nampa, Idaho—just east of Lake Lowell and at the center of one of the Treasure Valley’s most rapidly developing areas. Nestled next door to the CWI College Campus and the Ford Idaho Center—home to concerts, events, and year-round festivals—Laguna Farms puts you right where the action is.",
        "Conveniently located just off I-84, you're only a 20-minute drive from the heart of downtown Boise and just minutes from Meridian. Plus, with dozens of restaurants, shopping centers, grocery stores, and everyday conveniences just down the street, everything you need is right at your fingertips.",
        "Laguna Farms offers three distinct townhome models, all designed with open floorplans, abundant natural light, attached garages, and modern finishes. Whether you're commuting, exploring, or enjoying everything nearby, this community makes it easy to live in comfort and stay connected."
      ],
      image: {
        src: "https://cdn.maxxpm.com/stockphotos/living room.jpg",
        alt: "Staged Living Room",
      },
    },
    floorplanTitle: "Explore Our Floor Plans and Take a 3D Virtual Tour",
    floorplans: [
      {
        hasImage: true,
        image: {
          src: "https://cdn.maxxpm.com/lagunafarms/3storypayton/Laguna Payton's-01.jpg",
          alt: "Payton Model Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          src: "https://my.matterport.com/show/?m=H5AC7vTrP4k",
          title: "Payton model 3d walkthrough",
        },
      },
      {
        hasImage: true,
        image: {
          src: "https://cdn.maxxpm.com/lagunafarms/2storydelinda/Laguna Delinda-01.jpg",
          alt: "Delinda Model Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          src: "https://my.matterport.com/show/?m=Rpwhu7yof4v",
          title: "Delinda model 3d walkthrough",
        },
      },
      {
        hasImage: true,
        image: {
          src: "https://cdn.maxxpm.com/lagunafarms/2storytucker/Laguna Tucker.jpg",
          alt: "Tucker Model Floor Plan",
        },
        hasWalkthrough: true,
        walkthrough: {
          src: "https://my.matterport.com/show/?m=cVi1NQoL4gQ",
          title: "Tucker model 3d walkthrough",
        },
      },
    ],
    midContainerImage: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/yellow backpack hiker.jpg",
    imgRow: [
      {
        src: "https://cdn.maxxpm.com/lagunafarms/Website Photos/_DSC0409-Edit.jpg",
        alt: "Laguna Farms playground",
      },
      {
        src: "https://cdn.maxxpm.com/lagunafarms/Website Photos/FT9A6030-2.jpg",
        alt: "Laguna Farms Kitchen",
      },
      {
        src: "https://cdn.maxxpm.com/lagunafarms/Website Photos/_DSC0454-Edit.jpg",
        alt: "Laguna Farms garages",
      },
    ],
    animalPolicy: {
      img: {
        src: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/white dog blue couch.jpg",
        alt: "Animal policy stock photo",
      },
      policies: [
        "No more than 2 animals are allowed per property",
        "Cats/Dogs: $250/animal*",
        "$50/animal/month for animals under 50lbs*",
        "$75/animal/month for animals 50lbs+*",
        "One-time $75/animal DNA testing fee*",
        "Caged animals: $25/animal/month*",
        "Fish tanks are not permitted",
        "Small, caged mammals are not permitted, including but not limited to: rats, mice, hamsters, rabbits, guinea pigs, ferrets, sugar gliders, and hedgehogs",
      ],
      breedRestrictions: ["Pit Bulls & Staffordshire Terriers", "Doberman Pinschers", "Rottweilers", "Chows", "Great Danes", "Presa Canarios/ Mastiffs", "Akitas", "Alaskan Malamutes", "Huskies", "German Shepherds", "Shar Peis", "Wolf-Hybrids"],
    },
  },
  availability: {
    banner: {
      image: "https://cdn.maxxpm.com/lagunafarms/Website Photos/_DSC0413-Edit.jpg",
      video: undefined,
      title: "Available Units",
      subtitle: "Unit availability is updated often from Monday-Friday during business hours. Evenings and weekends may not reflect accurate availability dates.",
    },
    hasWaitingList: false,
    waitingListJotformId: undefined,
    propertyGroup: "LEADS-LF",
  },
  faq: {
    banner: {
      image: "https://cdn.maxxpm.com/lagunafarms/logoandbanners/girls on bed with dog.jpg",
    },
    dnaRequired: true,
  },
};
